import config from "../config/index";

const user = JSON.parse(localStorage.getItem('fgfleetuser')) || {}

const store = {
  state: {
    ...config,
    user,
    tabTemp: {},
    store: {},
    tabdata: null,
  },
  mutations: {
    setUserInfo(state, user) {
      localStorage.setItem('fgfleetuser', JSON.stringify(user))
      state.user = user
    },
    setTabIdx(state, { path, idx }) {
      state.tabTemp[path] = idx
      // console.log(state.tabTemp)
    },
    setState(state, { key, value }) {
      state.store[key] = value
      // console.log(state)
    },
    setTabData(state, value) {
      state.tabdata = value
      // console.log(state)
    },
  },
  getters: {
    tabIdxMemo: state => path => {
      // console.log(state.tabTemp)
      return state.tabTemp[path]
    },
  },
}

export default store